import * as RadixToast from '@radix-ui/react-toast';
import { ReactNode } from 'react';
import { cn } from '../utils/className';

interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  variant?: 'success' | 'error' | 'info';
  duration?: number;
}

export function Toast({
  open,
  onOpenChange,
  description,
  variant = 'info',
  duration = 3000,
}: ToastProps) {
  const variantStyles = {
    success: 'bg-surface-focus',
    error: 'bg-red-600',
    info: 'bg-surface-focus',
  };

  return (
    <RadixToast.Root
      open={open}
      onOpenChange={onOpenChange}
      duration={duration}
      className={cn(
        'rounded-lg p-3 shadow-[0_8px_30px_rgb(0,0,0,0.12)]',
        'transition-all duration-300 ease-out',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[swipe=end]:animate-out',
        `data-[state=closed]:fade-out-0
        data-[state=closed]:slide-out-to-right-full`,
        'data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-bottom-4',
        variantStyles[variant]
      )}
    >
      {description && (
        <RadixToast.Description className='size-p2 text-inverted'>
          {description}
        </RadixToast.Description>
      )}
    </RadixToast.Root>
  );
}

interface ToastProviderProps {
  children: ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <RadixToast.Provider swipeDirection='right'>
      {children}
      <RadixToast.Viewport
        className='fixed top-0 right-0 z-100 flex max-h-screen w-full
          flex-col-reverse p-4 sm:top-auto sm:right-0 sm:bottom-0 sm:flex-col
          md:max-w-105'
      />
    </RadixToast.Provider>
  );
}
